let apiUrl

const locationHref = location.href

if (locationHref.indexOf('localhost') > 0) {
  apiUrl = 'http://localhost:8081/api'
} else if (locationHref.indexOf('.b.') > 0) {
  apiUrl = 'http://api.b.baishan777.com'
} else { // 线上
  apiUrl = 'http://api.baishan777.com'
}
let appId = 'wx986338ccc2bcba0a'
export default {
  apiUrl: apiUrl,
  appId: appId
}
